import { RouteConfig } from 'vue-router'
import { universityRoutes } from '../constants/agency/'
const loginCode = '7$ZCh!A'
export const university: RouteConfig[] = [
  {
    path: '/university',
    name: universityRoutes.default,
    component: {},
    meta: {
      RedirectExternalUrl:
        'https://university.gohighlevel.com/?loginCode='+loginCode,
    },
  },
]
